import React from 'react';
import { FilterIcon } from '@/components/icons/FilterIcon';

type PoolListHeaderProps = {
  onShowFilters: () => void;
};

export const PoolListFilterButton: React.FC<PoolListHeaderProps> = ({ onShowFilters }) => {
  return (
    <div className="flex items-center gap-4">
      <button
        onClick={onShowFilters}
        className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
      >
        <FilterIcon />
        <span className="text-sm font-medium text-black [font-family:var(--ep-font-avenir)]">Filters</span>
      </button>
    </div>
  );
};
